import { default as indexdrG1xoXxosMeta } from "/opt/build/repo/pages/agricoltura/index.vue?macro=true";
import { default as indexaQMnV6PtKiMeta } from "/opt/build/repo/pages/azienda/index.vue?macro=true";
import { default as alta_45fermentazioneZddrZpRFmPMeta } from "/opt/build/repo/pages/birra/[slug]/alta-fermentazione.vue?macro=true";
import { default as bassa_45fermentazioneYAUX1KTsLXMeta } from "/opt/build/repo/pages/birra/[slug]/bassa-fermentazione.vue?macro=true";
import { default as indexyKOTaa2uIdMeta } from "/opt/build/repo/pages/birra/[slug]/index.vue?macro=true";
import { default as lieviti_45liquidiraIawkdZCtMeta } from "/opt/build/repo/pages/birra/[slug]/lieviti-liquidi.vue?macro=true";
import { default as indexlHNHiu43WsMeta } from "/opt/build/repo/pages/birra/index.vue?macro=true";
import { default as indexKPndcMHCjEMeta } from "/opt/build/repo/pages/come-fare-per/[slug]/index.vue?macro=true";
import { default as _91product_93kDXfBxnjpSMeta } from "/opt/build/repo/pages/contatti/[product].vue?macro=true";
import { default as indexU71mUg00ZkMeta } from "/opt/build/repo/pages/contatti/index.vue?macro=true";
import { default as indexQ7EC96mn4oMeta } from "/opt/build/repo/pages/cookie-policy/index.vue?macro=true";
import { default as indexpUllenSJXDMeta } from "/opt/build/repo/pages/copyright/index.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as index9OtlrnI1eyMeta } from "/opt/build/repo/pages/modalita-d-uso/[slug]/index.vue?macro=true";
import { default as indexPPJe7iS3pHMeta } from "/opt/build/repo/pages/news/[slug]/index.vue?macro=true";
import { default as indexJy3Y0vyEqXMeta } from "/opt/build/repo/pages/news/archivio/index.vue?macro=true";
import { default as index8k4xMa35gmMeta } from "/opt/build/repo/pages/news/index.vue?macro=true";
import { default as indexN8utcZqBMmMeta } from "/opt/build/repo/pages/nutraceutica/index.vue?macro=true";
import { default as indexlglsQYNzagMeta } from "/opt/build/repo/pages/panificati/index.vue?macro=true";
import { default as indexcUgXZ36ExVMeta } from "/opt/build/repo/pages/perche-noi/index.vue?macro=true";
import { default as index9d90rQCWYDMeta } from "/opt/build/repo/pages/privacy-policy/index.vue?macro=true";
import { default as _91slug_93z9YjsLE22iMeta } from "/opt/build/repo/pages/product/[slug].vue?macro=true";
import { default as indexUqY99HW9dmMeta } from "/opt/build/repo/pages/risorse/index.vue?macro=true";
import { default as indexUDdunI5WsmMeta } from "/opt/build/repo/pages/servizi/index.vue?macro=true";
import { default as indexHywOwrrRBpMeta } from "/opt/build/repo/pages/vino/[slug]/[sottocategoria]/index.vue?macro=true";
import { default as autoctoni99Tp9GYKVdMeta } from "/opt/build/repo/pages/vino/[slug]/autoctoni.vue?macro=true";
import { default as indexpJ5qX7EI0SMeta } from "/opt/build/repo/pages/vino/[slug]/index.vue?macro=true";
import { default as lieviti_45non_45saccharomycesuozvK1QiS0Meta } from "/opt/build/repo/pages/vino/[slug]/lieviti-non-saccharomyces.vue?macro=true";
import { default as lieviti_45per_45spumante0oGz2KuS00Meta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-spumante.vue?macro=true";
import { default as lieviti_45per_45vini_45aromaticidSlfjgbBpkMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-aromatici.vue?macro=true";
import { default as lieviti_45per_45vini_45dolciZ6Mhq5Vu2OMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-dolci.vue?macro=true";
import { default as lieviti_45per_45vini_45senza_45solfitigYvk2WTFZVMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-senza-solfiti.vue?macro=true";
import { default as lieviti_45per_45vino_45bianco9b2lqddLybMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-bianco.vue?macro=true";
import { default as lieviti_45per_45vino_45rosatovM3tFFRZeeMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosato.vue?macro=true";
import { default as lieviti_45per_45vino_45rossosVY40m6qCjMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosso.vue?macro=true";
import { default as lieviti_45saccharomycesmidOox1D1YMeta } from "/opt/build/repo/pages/vino/[slug]/lieviti-saccharomyces.vue?macro=true";
import { default as indexBtaUVieF2RMeta } from "/opt/build/repo/pages/vino/index.vue?macro=true";
import { default as component_45stubzRZTK7msC0Meta } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_ma_0c549da0b51d0dd9114fd09ade062f5e/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubzRZTK7msC0 } from "/opt/build/repo/node_modules/.pnpm/nuxt@3.14.1592_@parcel+watcher@2.5.0_@types+node@22.10.2_eslint@8.57.1_ioredis@5.4.1_ma_0c549da0b51d0dd9114fd09ade062f5e/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "agricoltura___it",
    path: "/agricoltura",
    component: () => import("/opt/build/repo/pages/agricoltura/index.vue")
  },
  {
    name: "agricoltura___en",
    path: "/en/agriculture",
    component: () => import("/opt/build/repo/pages/agricoltura/index.vue")
  },
  {
    name: "agricoltura___es",
    path: "/es/agricultura",
    component: () => import("/opt/build/repo/pages/agricoltura/index.vue")
  },
  {
    name: "agricoltura___fr",
    path: "/fr/agriculture",
    component: () => import("/opt/build/repo/pages/agricoltura/index.vue")
  },
  {
    name: "azienda___it",
    path: "/azienda",
    component: () => import("/opt/build/repo/pages/azienda/index.vue")
  },
  {
    name: "azienda___en",
    path: "/en/company",
    component: () => import("/opt/build/repo/pages/azienda/index.vue")
  },
  {
    name: "azienda___es",
    path: "/es/agencia",
    component: () => import("/opt/build/repo/pages/azienda/index.vue")
  },
  {
    name: "azienda___fr",
    path: "/fr/agence",
    component: () => import("/opt/build/repo/pages/azienda/index.vue")
  },
  {
    name: "birra-slug-alta-fermentazione___it",
    path: "/birra/:slug()/alta-fermentazione",
    component: () => import("/opt/build/repo/pages/birra/[slug]/alta-fermentazione.vue")
  },
  {
    name: "birra-slug-alta-fermentazione___en",
    path: "/en/beer/:slug()/high-fermentation",
    component: () => import("/opt/build/repo/pages/birra/[slug]/alta-fermentazione.vue")
  },
  {
    name: "birra-slug-alta-fermentazione___es",
    path: "/es/cerveza/:slug()/alta-fermentacion",
    component: () => import("/opt/build/repo/pages/birra/[slug]/alta-fermentazione.vue")
  },
  {
    name: "birra-slug-alta-fermentazione___fr",
    path: "/fr/biere/:slug()/levures-de-haute-fermentation",
    component: () => import("/opt/build/repo/pages/birra/[slug]/alta-fermentazione.vue")
  },
  {
    name: "birra-slug-bassa-fermentazione___it",
    path: "/birra/:slug()/bassa-fermentazione",
    component: () => import("/opt/build/repo/pages/birra/[slug]/bassa-fermentazione.vue")
  },
  {
    name: "birra-slug-bassa-fermentazione___en",
    path: "/en/beer/:slug()/low-fermentation",
    component: () => import("/opt/build/repo/pages/birra/[slug]/bassa-fermentazione.vue")
  },
  {
    name: "birra-slug-bassa-fermentazione___es",
    path: "/es/cerveza/:slug()/baja-fermentacion",
    component: () => import("/opt/build/repo/pages/birra/[slug]/bassa-fermentazione.vue")
  },
  {
    name: "birra-slug-bassa-fermentazione___fr",
    path: "/fr/biere/:slug()/levures-de-basse-fermentation",
    component: () => import("/opt/build/repo/pages/birra/[slug]/bassa-fermentazione.vue")
  },
  {
    name: "birra-slug___it",
    path: "/birra/:slug()",
    component: () => import("/opt/build/repo/pages/birra/[slug]/index.vue")
  },
  {
    name: "birra-slug___en",
    path: "/en/beer/:slug()",
    component: () => import("/opt/build/repo/pages/birra/[slug]/index.vue")
  },
  {
    name: "birra-slug___es",
    path: "/es/cerveza/:slug()",
    component: () => import("/opt/build/repo/pages/birra/[slug]/index.vue")
  },
  {
    name: "birra-slug___fr",
    path: "/fr/biere/:slug()",
    component: () => import("/opt/build/repo/pages/birra/[slug]/index.vue")
  },
  {
    name: "birra-slug-lieviti-liquidi___it",
    path: "/birra/lieviti-liquidi",
    component: () => import("/opt/build/repo/pages/birra/[slug]/lieviti-liquidi.vue")
  },
  {
    name: "birra-slug-lieviti-liquidi___en",
    path: "/en/beer/liquid-yeasts",
    component: () => import("/opt/build/repo/pages/birra/[slug]/lieviti-liquidi.vue")
  },
  {
    name: "birra-slug-lieviti-liquidi___es",
    path: "/es/cerveza/levaduras-liquidas",
    component: () => import("/opt/build/repo/pages/birra/[slug]/lieviti-liquidi.vue")
  },
  {
    name: "birra-slug-lieviti-liquidi___fr",
    path: "/fr/biere/levures-liquides",
    component: () => import("/opt/build/repo/pages/birra/[slug]/lieviti-liquidi.vue")
  },
  {
    name: "birra___it",
    path: "/birra",
    component: () => import("/opt/build/repo/pages/birra/index.vue")
  },
  {
    name: "birra___en",
    path: "/en/beer",
    component: () => import("/opt/build/repo/pages/birra/index.vue")
  },
  {
    name: "birra___es",
    path: "/es/cerveza",
    component: () => import("/opt/build/repo/pages/birra/index.vue")
  },
  {
    name: "birra___fr",
    path: "/fr/biere",
    component: () => import("/opt/build/repo/pages/birra/index.vue")
  },
  {
    name: "come-fare-per-slug___it",
    path: "/come-fare-per/:slug()",
    component: () => import("/opt/build/repo/pages/come-fare-per/[slug]/index.vue")
  },
  {
    name: "come-fare-per-slug___en",
    path: "/en/how-to/:slug()",
    component: () => import("/opt/build/repo/pages/come-fare-per/[slug]/index.vue")
  },
  {
    name: "come-fare-per-slug___es",
    path: "/es/como-hacer-para/:slug()",
    component: () => import("/opt/build/repo/pages/come-fare-per/[slug]/index.vue")
  },
  {
    name: "come-fare-per-slug___fr",
    path: "/fr/comment-faire-pour/:slug()",
    component: () => import("/opt/build/repo/pages/come-fare-per/[slug]/index.vue")
  },
  {
    name: "contatti-product___it",
    path: "/contatti/:product()",
    component: () => import("/opt/build/repo/pages/contatti/[product].vue")
  },
  {
    name: "contatti-product___en",
    path: "/en/contacts/:product()",
    component: () => import("/opt/build/repo/pages/contatti/[product].vue")
  },
  {
    name: "contatti-product___es",
    path: "/es/contactos/:product()",
    component: () => import("/opt/build/repo/pages/contatti/[product].vue")
  },
  {
    name: "contatti-product___fr",
    path: "/fr/contacts/:product()",
    component: () => import("/opt/build/repo/pages/contatti/[product].vue")
  },
  {
    name: "contatti___it",
    path: "/contatti",
    component: () => import("/opt/build/repo/pages/contatti/index.vue")
  },
  {
    name: "contatti___en",
    path: "/en/contacts",
    component: () => import("/opt/build/repo/pages/contatti/index.vue")
  },
  {
    name: "contatti___es",
    path: "/es/contactos",
    component: () => import("/opt/build/repo/pages/contatti/index.vue")
  },
  {
    name: "contatti___fr",
    path: "/fr/contacts",
    component: () => import("/opt/build/repo/pages/contatti/index.vue")
  },
  {
    name: "cookie-policy___it",
    path: "/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy/index.vue")
  },
  {
    name: "cookie-policy___en",
    path: "/en/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy/index.vue")
  },
  {
    name: "cookie-policy___es",
    path: "/es/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy/index.vue")
  },
  {
    name: "cookie-policy___fr",
    path: "/fr/cookie-policy",
    component: () => import("/opt/build/repo/pages/cookie-policy/index.vue")
  },
  {
    name: "copyright___it",
    path: "/copyright",
    component: () => import("/opt/build/repo/pages/copyright/index.vue")
  },
  {
    name: "copyright___en",
    path: "/en/copyright",
    component: () => import("/opt/build/repo/pages/copyright/index.vue")
  },
  {
    name: "copyright___es",
    path: "/es/derechos-de-autor",
    component: () => import("/opt/build/repo/pages/copyright/index.vue")
  },
  {
    name: "copyright___fr",
    path: "/fr/droits-dauteur",
    component: () => import("/opt/build/repo/pages/copyright/index.vue")
  },
  {
    name: "index___it",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "modalita-d-uso-slug___it",
    path: "/modalita-duso/:slug()",
    component: () => import("/opt/build/repo/pages/modalita-d-uso/[slug]/index.vue")
  },
  {
    name: "modalita-d-uso-slug___en",
    path: "/en/use-mode/:slug()",
    component: () => import("/opt/build/repo/pages/modalita-d-uso/[slug]/index.vue")
  },
  {
    name: "modalita-d-uso-slug___es",
    path: "/es/modo-de-uso/:slug()",
    component: () => import("/opt/build/repo/pages/modalita-d-uso/[slug]/index.vue")
  },
  {
    name: "modalita-d-uso-slug___fr",
    path: "/fr/mode-demploi/:slug()",
    component: () => import("/opt/build/repo/pages/modalita-d-uso/[slug]/index.vue")
  },
  {
    name: "news-slug___it",
    path: "/news/:slug()",
    component: () => import("/opt/build/repo/pages/news/[slug]/index.vue")
  },
  {
    name: "news-slug___en",
    path: "/en/news/:slug()",
    component: () => import("/opt/build/repo/pages/news/[slug]/index.vue")
  },
  {
    name: "news-slug___es",
    path: "/es/noticias/:slug()",
    component: () => import("/opt/build/repo/pages/news/[slug]/index.vue")
  },
  {
    name: "news-slug___fr",
    path: "/fr/actualites/:slug()",
    component: () => import("/opt/build/repo/pages/news/[slug]/index.vue")
  },
  {
    name: "news-archivio___it",
    path: "/news/archivio",
    component: () => import("/opt/build/repo/pages/news/archivio/index.vue")
  },
  {
    name: "news-archivio___en",
    path: "/en/news/archive",
    component: () => import("/opt/build/repo/pages/news/archivio/index.vue")
  },
  {
    name: "news-archivio___es",
    path: "/es/noticias/archivo",
    component: () => import("/opt/build/repo/pages/news/archivio/index.vue")
  },
  {
    name: "news-archivio___fr",
    path: "/fr/actualites/archives",
    component: () => import("/opt/build/repo/pages/news/archivio/index.vue")
  },
  {
    name: "news___it",
    path: "/news",
    component: () => import("/opt/build/repo/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/opt/build/repo/pages/news/index.vue")
  },
  {
    name: "news___es",
    path: "/es/noticias",
    component: () => import("/opt/build/repo/pages/news/index.vue")
  },
  {
    name: "news___fr",
    path: "/fr/actualites",
    component: () => import("/opt/build/repo/pages/news/index.vue")
  },
  {
    name: "nutraceutica___it",
    path: "/nutraceutica",
    component: () => import("/opt/build/repo/pages/nutraceutica/index.vue")
  },
  {
    name: "nutraceutica___en",
    path: "/en/nutraceuticals",
    component: () => import("/opt/build/repo/pages/nutraceutica/index.vue")
  },
  {
    name: "nutraceutica___es",
    path: "/es/nutraceutica",
    component: () => import("/opt/build/repo/pages/nutraceutica/index.vue")
  },
  {
    name: "nutraceutica___fr",
    path: "/fr/nutraceutique",
    component: () => import("/opt/build/repo/pages/nutraceutica/index.vue")
  },
  {
    name: "panificati___it",
    path: "/panificati",
    component: () => import("/opt/build/repo/pages/panificati/index.vue")
  },
  {
    name: "panificati___en",
    path: "/en/bakery-products",
    component: () => import("/opt/build/repo/pages/panificati/index.vue")
  },
  {
    name: "panificati___es",
    path: "/es/panaderia",
    component: () => import("/opt/build/repo/pages/panificati/index.vue")
  },
  {
    name: "panificati___fr",
    path: "/fr/produits-boulangers",
    component: () => import("/opt/build/repo/pages/panificati/index.vue")
  },
  {
    name: "perche-noi___it",
    path: "/perche-noi",
    component: () => import("/opt/build/repo/pages/perche-noi/index.vue")
  },
  {
    name: "perche-noi___en",
    path: "/en/why-us",
    component: () => import("/opt/build/repo/pages/perche-noi/index.vue")
  },
  {
    name: "perche-noi___es",
    path: "/es/por-que-nosotros",
    component: () => import("/opt/build/repo/pages/perche-noi/index.vue")
  },
  {
    name: "perche-noi___fr",
    path: "/fr/pourquoi-nous",
    component: () => import("/opt/build/repo/pages/perche-noi/index.vue")
  },
  {
    name: "privacy-policy___it",
    path: "/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___es",
    path: "/es/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___fr",
    path: "/fr/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy/index.vue")
  },
  {
    name: "product-slug___it",
    path: "/:slug()",
    component: () => import("/opt/build/repo/pages/product/[slug].vue")
  },
  {
    name: "product-slug___en",
    path: "/en/:slug()",
    component: () => import("/opt/build/repo/pages/product/[slug].vue")
  },
  {
    name: "product-slug___es",
    path: "/es/:slug()",
    component: () => import("/opt/build/repo/pages/product/[slug].vue")
  },
  {
    name: "product-slug___fr",
    path: "/fr/:slug()",
    component: () => import("/opt/build/repo/pages/product/[slug].vue")
  },
  {
    name: "risorse___it",
    path: "/risorse",
    component: () => import("/opt/build/repo/pages/risorse/index.vue")
  },
  {
    name: "risorse___en",
    path: "/en/resources",
    component: () => import("/opt/build/repo/pages/risorse/index.vue")
  },
  {
    name: "risorse___es",
    path: "/es/recursos",
    component: () => import("/opt/build/repo/pages/risorse/index.vue")
  },
  {
    name: "risorse___fr",
    path: "/fr/ressources",
    component: () => import("/opt/build/repo/pages/risorse/index.vue")
  },
  {
    name: "servizi___it",
    path: "/servizi",
    component: () => import("/opt/build/repo/pages/servizi/index.vue")
  },
  {
    name: "servizi___en",
    path: "/en/services",
    component: () => import("/opt/build/repo/pages/servizi/index.vue")
  },
  {
    name: "servizi___es",
    path: "/es/servicios",
    component: () => import("/opt/build/repo/pages/servizi/index.vue")
  },
  {
    name: "servizi___fr",
    path: "/fr/services",
    component: () => import("/opt/build/repo/pages/servizi/index.vue")
  },
  {
    name: "vino-slug-sottocategoria___it",
    path: "/vino/:slug()/:sottocategoria()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/[sottocategoria]/index.vue")
  },
  {
    name: "vino-slug-sottocategoria___en",
    path: "/en/wine/:slug()/:sottocategoria()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/[sottocategoria]/index.vue")
  },
  {
    name: "vino-slug-sottocategoria___es",
    path: "/es/vino/:slug()/:sottocategoria()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/[sottocategoria]/index.vue")
  },
  {
    name: "vino-slug-sottocategoria___fr",
    path: "/fr/vin/:slug()/:sottocategoria()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/[sottocategoria]/index.vue")
  },
  {
    name: "vino-slug-autoctoni___it",
    path: "/vino/:slug()/autoctoni",
    component: () => import("/opt/build/repo/pages/vino/[slug]/autoctoni.vue")
  },
  {
    name: "vino-slug-autoctoni___en",
    path: "/en/wine/:slug()/indigenous",
    component: () => import("/opt/build/repo/pages/vino/[slug]/autoctoni.vue")
  },
  {
    name: "vino-slug-autoctoni___es",
    path: "/es/vino/:slug()/autoctonos",
    component: () => import("/opt/build/repo/pages/vino/[slug]/autoctoni.vue")
  },
  {
    name: "vino-slug-autoctoni___fr",
    path: "/fr/vin/:slug()/indigenes",
    component: () => import("/opt/build/repo/pages/vino/[slug]/autoctoni.vue")
  },
  {
    name: "vino-slug___it",
    path: "/vino/:slug()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/index.vue")
  },
  {
    name: "vino-slug___en",
    path: "/en/wine/:slug()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/index.vue")
  },
  {
    name: "vino-slug___es",
    path: "/es/vino/:slug()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/index.vue")
  },
  {
    name: "vino-slug___fr",
    path: "/fr/vin/:slug()",
    component: () => import("/opt/build/repo/pages/vino/[slug]/index.vue")
  },
  {
    name: "vino-slug-lieviti-non-saccharomyces___it",
    path: "/vino/:slug()/lieviti-non-saccharomyces",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-non-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-non-saccharomyces___en",
    path: "/en/wine/:slug()/non-saccharomyces-yeasts",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-non-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-non-saccharomyces___es",
    path: "/es/vino/:slug()/levaduras-no-saccharomyces",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-non-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-non-saccharomyces___fr",
    path: "/fr/vin/:slug()/levures-non-saccharomyces",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-non-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-per-spumante___it",
    path: "/vino/:slug()/lieviti-per-spumante",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-spumante.vue")
  },
  {
    name: "vino-slug-lieviti-per-spumante___en",
    path: "/en/wine/:slug()/sparkling-wine-yeast",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-spumante.vue")
  },
  {
    name: "vino-slug-lieviti-per-spumante___es",
    path: "/es/vino/:slug()/levaduras-para-vino-espumoso",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-spumante.vue")
  },
  {
    name: "vino-slug-lieviti-per-spumante___fr",
    path: "/fr/vin/:slug()/levures-pour-vins-mousseux",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-spumante.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-aromatici___it",
    path: "/vino/:slug()/lieviti-per-vini-aromatici",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-aromatici.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-aromatici___en",
    path: "/en/wine/:slug()/yeasts-for-aromatic-wines",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-aromatici.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-aromatici___es",
    path: "/es/vino/:slug()/levaduras-para-vinos-arom%C3%A1ticos",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-aromatici.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-aromatici___fr",
    path: "/fr/vin/:slug()/levures-pour-vins-aromatiques",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-aromatici.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-dolci___it",
    path: "/vino/:slug()/lieviti-per-vini-dolci",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-dolci.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-dolci___en",
    path: "/en/wine/:slug()/yeasts-for-sweet-wines",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-dolci.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-dolci___es",
    path: "/es/vino/:slug()/levaduras-para-vino-dulce",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-dolci.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-dolci___fr",
    path: "/fr/vin/:slug()/levures-pour-vin-doux",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-dolci.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-senza-solfiti___it",
    path: "/vino/:slug()/lieviti-per-vini-senza-solfiti",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-senza-solfiti.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-senza-solfiti___en",
    path: "/en/wine/:slug()/yeasts-for-sulfite-free-wines",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-senza-solfiti.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-senza-solfiti___es",
    path: "/es/vino/:slug()/levaduras-para-vinos-sin-sulfitos",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-senza-solfiti.vue")
  },
  {
    name: "vino-slug-lieviti-per-vini-senza-solfiti___fr",
    path: "/fr/vin/:slug()/levures-pour-vins-sans-sulfites",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vini-senza-solfiti.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-bianco___it",
    path: "/vino/:slug()/lieviti-per-vino-bianco",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-bianco.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-bianco___en",
    path: "/en/wine/:slug()/yeasts-for-white-wine",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-bianco.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-bianco___es",
    path: "/es/vino/:slug()/levaduras-para-vino-blanco",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-bianco.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-bianco___fr",
    path: "/fr/vin/:slug()/levures-pour-le-vin-blanc",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-bianco.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosato___it",
    path: "/vino/:slug()/lieviti-per-vino-rosato",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosato.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosato___en",
    path: "/en/wine/:slug()/yeasts-for-rose-wine",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosato.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosato___es",
    path: "/es/vino/:slug()/levaduras-para-vino-rosado",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosato.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosato___fr",
    path: "/fr/vin/:slug()/levures-pour-vins-rose",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosato.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosso___it",
    path: "/vino/:slug()/lieviti-per-vino-rosso",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosso.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosso___en",
    path: "/en/wine/:slug()/yeasts-for-red-wine",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosso.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosso___es",
    path: "/es/vino/:slug()/levaduras-para-vino-tinto",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosso.vue")
  },
  {
    name: "vino-slug-lieviti-per-vino-rosso___fr",
    path: "/fr/vin/:slug()/levures-pour-vin-rouge",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-per-vino-rosso.vue")
  },
  {
    name: "vino-slug-lieviti-saccharomyces___it",
    path: "/vino/:slug()/lieviti-saccharomyces",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-saccharomyces___en",
    path: "/en/wine/:slug()/saccharomyces-yeasts",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-saccharomyces___es",
    path: "/es/vino/:slug()/levaduras-saccharomyces",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-saccharomyces.vue")
  },
  {
    name: "vino-slug-lieviti-saccharomyces___fr",
    path: "/fr/vin/:slug()/levures-saccharomyces",
    component: () => import("/opt/build/repo/pages/vino/[slug]/lieviti-saccharomyces.vue")
  },
  {
    name: "vino___it",
    path: "/vino",
    component: () => import("/opt/build/repo/pages/vino/index.vue")
  },
  {
    name: "vino___en",
    path: "/en/wine",
    component: () => import("/opt/build/repo/pages/vino/index.vue")
  },
  {
    name: "vino___es",
    path: "/es/vino",
    component: () => import("/opt/build/repo/pages/vino/index.vue")
  },
  {
    name: "vino___fr",
    path: "/fr/vin",
    component: () => import("/opt/build/repo/pages/vino/index.vue")
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/la-stabilita-tartarica/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/malolattica-e-maloalcolica/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/tannini/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/chiarificanti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/stabilizzanti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/enzimi/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/attivanti-e-nutrienti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti-in-crema/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/lieviti-atecnos-per-birra-belgian-ales/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/lieviti-atecnos-per-birra-ales/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/american-stout/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/american-amber-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/senza-solfiti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/vini-rossi/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/supporto-faqs/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/blonde-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/difendersi-dal-brett/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/lieviti-atecnos-per-birra-wheats/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/biologico-atecnos/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/american-pale-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema-atecnos-innovativi---non-solfuri---produttori-di-acido-malico",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/nuovi-prodotti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema-atecnos-aromatici/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/super-tannini/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/news/bioenologia-2-0-sostiene-la-cultura-siamo-main-sponsor-della-mostra-allestita-a-oderzo-per-il-70-anniversario-dalla-morte-di-alberto-martini",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/autolisati-atecnos/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/spumanti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/lieviti-atecnos-per-birra-sour-beer/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/estratti-per-aroma-e-colore/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/american-brown-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/news/green-mountain-una-marcia-in-più-per-la-tua-birra/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema-atecnos-non-saccharomyces/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/news/la-crisi-non-rallenta-gli-imprenditori-visionari-il-caso-bioenologia-2-0-pololab",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/trattamenti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema-atecnos-innovativi-no-solfuri/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/guida-acquisto/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/ricerca-e-sviluppo/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/risolvere-lossidazione/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/vini-dolci/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/lieviti-atecnos-per-birra-lagers/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti-autoctoni/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/vini-aromatici/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/pane-e-pizza/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/lieviti-atecnos-per-sidro/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema-atecnos-ultra-performanti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/vini-bianchi/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/attivanti-di-fermentazione/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/protocollo-generale-per-lavviamento-su-mosti-e-vini-specifico-per-lievito-atecrem-12-h",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/dosaggi-retinex/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/avvertenze-generali-lieviti-atecrem/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/protocollo-generale-per-avviamento-su-mosti-e-vini/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/dosaggi-retinex-5/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/retinex-e-flix-regole-generali-per-il-corretto-uso/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/protocollo-per-presa-di-spuma/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/protocollo-generale-per-avviamento-lieviti-per-birra/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/ateflow-german-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti-in-crema-atecnos-ales/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birre-lager-fermentate-alta-temperatura/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti-liquidi-atecnos-wheats/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/maxivis-2-1/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/american-cream-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti-in-crema-atecnos-belgian-ales/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lager/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/lieviti-in-crema-atecnos-lagers/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/saison/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birra/american-ipa/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/stout/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/belgian-dark-strong-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/belgian-dubbel-trippel/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/belgian-pale-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/belgian-strong-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/berliner-weisse/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/bière-de-garde/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/birre-speziate-ed-aromatiche/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/english-ipa/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/english-old-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/fruit-beer/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/imperial-ipa/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/russian-imperial-stout/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/new-england-ipa/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/oatmeal-stout/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/porter/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/scottish-heavy/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/scottish-light/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/dry-stout/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/english-barleywine/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/english-brown-ale/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vini-aromatici/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/senza-solfiti/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti/lieviti-per-vini-bianchi/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti/lieviti-per-vini-rossi/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema/non-saccharomyces/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/vino/lieviti-in-crema/saccharomyces/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/witbier/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/traditional-bock/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/pilsner-tedesche-cecoslovacche/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/kolsch/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/bock/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/dopplebock/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/marzen/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/munchener-dunkel/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/oktoberfest-marzen/",
    component: component_45stubzRZTK7msC0
  },
  {
    name: component_45stubzRZTK7msC0Meta?.name,
    path: "/sitemap.xml",
    component: component_45stubzRZTK7msC0
  }
]